import types from '../../../mutation-types';
import MessageApi from '../../../../api/inbox/message';

export default {
  async translateMessage(
    { commit, state },
    { conversationId, messageId, targetLanguage }
  ) {
    const { data } = await MessageApi.translateMessage(
      conversationId,
      messageId,
      targetLanguage
    );

    const conversation = state.allConversations.find(
      item => Number(item.id) === Number(conversationId)
    );
    const existingMessage = conversation?.messages?.find(
      item => Number(item.id) === Number(messageId)
    );

    commit(types.ADD_MESSAGE, {
      ...existingMessage,
      ...data,
      content_attributes: {
        ...(existingMessage?.content_attributes || {}),
        ...(data.content_attributes || {}),
      },
    });
    return data;
  },
};
